import {
  Flag,
  Users,
  Target,
  Zap,
  LineChart,
  CheckCircle2,
} from 'lucide-react';
import { DebriefStage } from '@momentum/types';

export const STAGE_META = {
  [DebriefStage.GoalAndLeadDefinition]: {
    icon: Flag,
    labelKey: 'gather.stageLabels.goalAndLeadDefinition',
  },
  [DebriefStage.TeamAssembly]: {
    icon: Users,
    labelKey: 'gather.stageLabels.teamAssembly',
  },
  [DebriefStage.Planning]: {
    icon: Target,
    labelKey: 'gather.stageLabels.planning',
  },
  [DebriefStage.Execution]: {
    icon: Zap,
    labelKey: 'gather.stageLabels.execution',
  },
  [DebriefStage.MonitoringAndControl]: {
    icon: LineChart,
    labelKey: 'gather.stageLabels.monitoringAndControl',
  },
  [DebriefStage.CompletionAndApproval]: {
    icon: CheckCircle2,
    labelKey: 'gather.stageLabels.completionAndApproval',
  },
} as const;

export const STAGE_ORDER: readonly DebriefStage[] = [
  DebriefStage.GoalAndLeadDefinition,
  DebriefStage.TeamAssembly,
  DebriefStage.Planning,
  DebriefStage.Execution,
  DebriefStage.MonitoringAndControl,
  DebriefStage.CompletionAndApproval,
];
